import React,{useState,useEffect} from 'react'
import {Toast,ToastBody,ToastHeader} from "reactstrap";

function ToastComp(props) {
  const [toast, setToast] = useState(true);
  useEffect(() => {
    setToast(true)
    const intervalTimer = setInterval(() => {setToast(false)}, 4000);
    return(()=>{
      clearInterval(intervalTimer)
    })
  }, [props]);
  
  
    return toast ? (
      <div className={'p-3 my-2 float-right w-25 bg-' + props.type + ' rounded text-center position-sticky bottom-0'}>
        {}
          <Toast>
          <ToastHeader>
              {props.tittle}
          </ToastHeader>
          <ToastBody>
              {props.text}
          </ToastBody>
          </Toast>
      </div>
    ) : null
  
}

export default ToastComp